export const ParticipantEmailTag = '||PARTICIPANT||';
